var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2F3641","fillRule":"evenodd","d":"M15.1716035,12.7573899 L18.7071068,16.2928932 L17.2928932,17.7071068 L13.7573899,14.1716035 C12.9669569,14.6951232 12.0190823,15 11,15 C8.23857625,15 6,12.7614237 6,10 C6,7.23857625 8.23857625,5 11,5 C13.7614237,5 16,7.23857625 16,10 C16,11.0190823 15.6951232,11.9669569 15.1716035,12.7573899 Z M11,13 C12.6568542,13 14,11.6568542 14,10 C14,8.34314575 12.6568542,7 11,7 C9.34314575,7 8,8.34314575 8,10 C8,11.6568542 9.34314575,13 11,13 Z"}));
}

SearchIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
